<p-overlayPanel
    #notificationPanel
    [showCloseIcon]="false"
    [style]="{ width: '420px', maxWidth: '95vw', '--company-color': companyColor }"
    [dismissable]="true"
    styleClass="notification-overlay"
>
    <ng-template pTemplate="content">
        <div class="notification-panel">
            <!-- Header -->
            <div class="notification-header">
                <div class="header-content">
                    <i class="pi pi-bell header-icon" [style.color]="companyColor"></i>
                    <h3>Notificaciones</h3>
                    <span class="notification-count" *ngIf="notifications.length > 0" [style.background-color]="companyColor">
                        {{ notifications.length }}
                    </span>
                </div>
                <button
                    *ngIf="notifications.length > 0"
                    (click)="markAllAsRead()"
                    pButton
                    label="Marcar todas"
                    icon="pi pi-check-double"
                    [style]="{
                        'color': companyColor,
                        'background': 'transparent',
                        'border': 'none',
                        'box-shadow': 'none',
                        'font-weight': '600',
                        'padding': '0.375rem 0.75rem',
                        'font-size': '0.85rem'
                    }"
                    class="p-button-text p-button-sm mark-all-read-btn"
                ></button>
            </div>

            <!-- Loading State -->
            <div class="notification-loading" *ngIf="isLoading">
                <div class="skeleton-item" *ngFor="let i of [1,2,3]">
                    <div class="skeleton-icon"></div>
                    <div class="skeleton-content">
                        <div class="skeleton-title"></div>
                        <div class="skeleton-body"></div>
                        <div class="skeleton-time"></div>
                    </div>
                </div>
            </div>

            <!-- Notifications List -->
            <div
                class="notification-list"
                *ngIf="!isLoading && notifications && notifications.length > 0"
            >
                <div
                    *ngFor="let notification of notifications"
                    class="notification-item"
                    [class.unread]="!notification.readAt"
                    [ngClass]="getPriorityClass(notification)"
                    (click)="onNotificationClick(notification)"
                >
                    <!-- Icon with color -->
                    <div 
                        class="notification-icon-wrapper"
                        [style.background-color]="getNotificationColor(notification) + '15'"
                    >
                        <i 
                            [class]="getNotificationIcon(notification)"
                            [style.color]="getNotificationColor(notification)"
                        ></i>
                    </div>

                    <!-- Content -->
                    <div class="notification-content">
                        <div class="notification-title" [class.font-bold]="!notification.readAt">
                            {{ notification.title }}
                        </div>
                        <div class="notification-body" [innerHTML]="notification.body"></div>
                        
                        <!-- Image preview if exists -->
                        <div class="notification-image" *ngIf="hasImage(notification)">
                            <img [src]="notification.imageUrl" [alt]="notification.title" class="feed-image-preview" />
                        </div>
                        
                        <div class="notification-footer">
                            <span class="notification-time">
                                <i class="pi pi-clock"></i>
                                {{ getTimeAgo(notification.createdOn) }}
                            </span>
                            
                            <!-- Priority badge -->
                            <span 
                                class="priority-badge"
                                *ngIf="notification.data?.priority === 'high'"
                            >
                                <i class="pi pi-exclamation-circle"></i>
                                Urgente
                            </span>
                        </div>
                    </div>

                    <!-- Unread indicator -->
                    <div class="notification-status" *ngIf="!notification.readAt">
                        <span class="unread-dot" [style.background-color]="companyColor" [style.box-shadow]="'0 0 0 3px ' + companyColor + '20'"></span>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div
                class="notification-empty"
                *ngIf="!isLoading && (!notifications || notifications.length === 0)"
            >
                <div class="empty-icon">
                    <i class="pi pi-bell-slash" [style.color]="companyColor + '50'"></i>
                </div>
                <h4>Todo al día</h4>
                <p>No tienes notificaciones pendientes</p>
            </div>

            <!-- Footer -->
            <div
                class="notification-footer-actions"
                *ngIf="!isLoading && notifications && notifications.length > 0"
            >
                <button
                    (click)="viewAllNotifications()"
                    pButton
                    label="Ver todas las notificaciones"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    [style]="{
                        'color': companyColor,
                        'border': '1px solid ' + companyColor,
                        'background': 'transparent',
                        'width': '100%',
                        'border-radius': '8px',
                        'font-weight': '600',
                        'padding': '0.5rem 1rem'
                    }"
                    class="p-button-outlined p-button-sm view-all-btn"
                ></button>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>